export const STYLE_INPUT =
  "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 text-base focus:border-brand-orange-medium focus:outline-none focus:ring-brand-orange-medium disabled:bg-gray-50";
export const STYLE_INPUT_MARGIN_TOP = "mt-1";
